import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const SuccessStoriesRootElement = styled.div`
    background: #161616;
    padding: 48px 0;
    .grid-col {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr 1fr;
        display: grid;
        @media (max-width: 1040px) {
            grid-template-columns: 1fr 1fr 1fr;
            @media (max-width: 991px) {
                grid-template-columns: 1fr 1fr;
                @media (max-width: 767px) {
                    grid-template-columns: 1fr;
                }
            }
        }
    }
    .MuiTypography-headline-medium {
        color: ${styleVariables.primitivesColor.primary.white};
        display: block;
    }
`;
export default SuccessStoriesRootElement;
